export default __webpack_public_path__ + "static/media/Gluten-Free.b72b4eec.svg";